<template>
  <router-link :to="{name: 'christmas'}" class="christmas is-block" v-if="$whitelabel.short.toLowerCase() === 'adac'">
    <div class="columns  is-multiline is-vcentered">
      <div class="column is-7-tablet is-5-widescreen is-6-desktop is-offset-0-desktop is-size-5-widescreen christmas__content christmas__content--adac mt-3">
        <div class="has-text-centered-mobile christmas__text--adac px-2">
          <div class="title is-inline-block is-size-3-mobile is-size-2-tablet is-size-1-widescreen has-text-weight-bold">
            <p class="has-background-secondary is-size-5 is-size-3-tablet is-size-2-fullhd is-inline-block has-text-weight-bold has-text-white pr-1 pl-1 mb-3">
              ADAC Hotelgutschein
            </p>

            <div class="is-size-2-tablet is-size-2-desktop is-size-2-widescreen is-size-1-fullhd christmas__headline--adac">
              <p>Verschenken Sie</p>
              <p style="line-height: 0.75">kostbare Zeit zu Zweit</p>
            </div>
          </div>

          <b-button tag="router-link" :to="{name: 'christmas'}" type="is-light" size="is-medium" class="mt-5 is-hidden-touch" icon-left="angle-double-right">
            Zu den Angeboten
          </b-button>
        </div>
      </div>
      <div class="column is-5-tablet is-7-widescreen is-6-desktop is-7-widescreen christmas__img--adac my-0">
        <p class=" has-text-centered has-text-right-desktop">
          <img
            importance="high"
            src="https://assets.urlaubsgutschein.kaufen/i/resize?width=780&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png"
            srcset="
              https://assets.urlaubsgutschein.kaufen/i/resize?width=402&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 402w,
              https://assets.urlaubsgutschein.kaufen/i/resize?width=700&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 700w,
              https://assets.urlaubsgutschein.kaufen/i/resize?width=278&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 278w,
              https://assets.urlaubsgutschein.kaufen/i/resize?width=476&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/weihnachten.png 476w
            "
            sizes="(max-width: 480px) 432px,
                (max-width: 768px) 720px,
                (max-width: 1024px) 382px,
                (max-width: 1216px) 556px,
                (max-width: 1408px) 652px,
            666px
                "
            alt="Weihnachtsspecials"
            width="718"
            height="353"
          />
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'Christmas',
  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.christmas {
  background-color: #fdda7b;
  background-image: url('https://template.we-are.travel/i/crop?width=760&height=530&interlace=true&quality=70&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  background-size: cover;

  @media screen and (min-width: 768px) {
    background-image: url('https://template.we-are.travel/i/crop?width=1144&height=350&interlace=true&quality=70&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  }
  @media screen and (min-width: 1216px) {
    background-image: url('https://template.we-are.travel/i/crop?width=1336&height=380&interlace=true&quality=70&type=auto&file=whitelabel/adac/campaigns/weihnachten-bg.jpg');
  }
}

.christmas {
  .title {
    margin-bottom: 0.75rem;
  }
}

.christmas__content {
  @media screen and (min-width: 769px) {
    margin-top: 3rem;
  }
}

@media screen and (min-width: 768px) {
  .christmas__text--adac {
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-left: 2.5rem;
    margin-right: 0;
  }
}

// @media screen and (min-width: 1418px) {
//   .christmas__headline--adac {
//     font-size: 4rem !important;
//   }
// }
</style>
